import * as React from 'react'
import type { CustomField } from 'types/business'
import Checkbox from 'components/ui/checkbox'
type Props = {
  field: CustomField
  checked: boolean
  onChange: (...args: Array<any>) => any
  className?: string
}

const MetadataCheckbox = ({
  field,
  checked,
  onChange,
  className,
}: Props): React.ReactElement<'div'> => {
  return (
    <div className={className}>
      <Checkbox
        label={field.text}
        checked={checked}
        onChange={onChange}
        disabled={!field.editable}
      />
    </div>
  )
}

export default MetadataCheckbox
